import Vue from 'vue'
import Vuex from 'vuex'
import VueYoutube from 'vue-youtube'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
Vue.use(VueYoutube)

const state = {
  fromLogin: false, /* ログイン画面からログインした時にtrue ルーティングで使う */
  IsLoggingIn: false,
  user: {},
  userDataMap: new Map(),
  userLikeMap: new Map(),
  viewingPage: null /* 匿名ユーザーがログイン画面に飛ばされる時に見ていたページ */
}

const getters = {
  getIsLoggingIn: state => {
    return state.IsLoggingIn
  }
}

const mutations = {
  setFromLogin (state, fromLogin) {
    state.fromLogin = fromLogin
  },
  setIsLoggingIn (state, IsLoggingIn) {
    state.IsLoggingIn = IsLoggingIn
  },
  setUserData (state, user) {
    state.user = user
  },
  setUserDataMap (state, userDataMap) {
    state.userDataMap = userDataMap
  },
  setUserLikeMap (state, userLikeMap) {
    state.userLikeMap = userLikeMap
  },
  setViewingPage (state, viewingPage) {
    state.viewingPage = viewingPage
  }
}

export default new Vuex.Store({
  state: state,
  mutations: mutations,
  getters: getters,
  plugins: [createPersistedState({
    key: 'example',
    storage: window.sessionStorage
  })]
})



// WEBPACK FOOTER //
// ./src/store/index.js